import { render, staticRenderFns } from "./oracle.vue?vue&type=template&id=5fb71722"
import script from "./oracle.vue?vue&type=script&lang=js"
export * from "./oracle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports